import React from "react";
import styled from "styled-components";
import {describeDateAndTimeOfEarnings} from "../../../stocks/earnings/StockEarnings";
import {Tooltip} from "antd";
import {contentMapping, getEarningsTime, getProximityDaysAwayFromPairOfEarnings} from "../../earnings/earnings";

const Container = styled.div`
    color: ${props => props.colour};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

const IconImg = styled.img`
    margin-top: 2px;
    margin-bottom: 2px;
    width: 16px;
    height: 16px;
`;

const When = styled.div`
    font-size: 10px;
`;

export const OpenIdeasEarnings = ({className, idea}) => {
    const earnings = {
        nextEarnings: idea.nextEarnings,
        previousEarnings: idea.previousEarnings
    }
    const closestEarnings = getProximityDaysAwayFromPairOfEarnings(earnings);
    if (closestEarnings == null) {
        return null;
    }
    const content = contentMapping[closestEarnings.daysFromToday];
    const earningsMessage = <div>
        <div>{closestEarnings.date}</div>
        <div>{getEarningsTime(closestEarnings)}</div>
    </div>;
    return <Tooltip title={earningsMessage}
                    overlayClassName="t-formatted-tooltip"
                    mouseLeaveDelay={0}>
        <Container className={className} colour={content.colour}>
            <IconImg src={content.image}/>
            <When className="t-when">{content.text}</When>
        </Container>
    </Tooltip>;
}